import { Error404Form } from '@src/features/error';
import CompanyCenterCardLayout from '@src/layouts/company/CompanyCenterCardLayout';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function Error404({ isTenant }: { isTenant: boolean }) {
  return isTenant ? (
    <TenantCenterCardLayout>
      <Error404Form isTenant={isTenant} />
    </TenantCenterCardLayout>
  ) : (
    <CompanyCenterCardLayout>
      <Error404Form isTenant={isTenant} />
    </CompanyCenterCardLayout>
  );
}

export default Error404;
